import Swal from "sweetalert2"

export const loginPopup = () => Swal.fire({
  customClass: {
    htmlContainer: "!text-left !text-blue dark:text-white !p-2",
  },
  html: `
    <img src="/images/logo-lawhub.png" alt="LST logo" class="h-10 w-auto mb-6"/>
    <div class="text-xl md:text-2xl font-semibold mb-6">
        Sign in to unlock the best of <br class="hidden md:inline"/> Law School Transparency
    </div>
    <ul class="list-none pl-0 space-y-3 mb-10 text-sm">
      <li class="flex gap-3">
        <i class="leading-snug fa-solid fa-circle-check text-green"></i>
        Find out how close a school's job outcomes are to your goals through the Job Score
      </li>
      <li class="flex gap-3">
        <i class="leading-snug fa-solid fa-circle-check text-green"></i>
        Calculate chances of admission based on your LSAT and GPA
      </li>
      <li class="flex gap-3">
        <i class="leading-snug fa-solid fa-circle-check text-green"></i>
        List of schools according to your location and job preferences
      </li>
      <li class="flex gap-3">
        <i class="leading-snug fa-solid fa-circle-check text-green"></i>
        Budget for each school and create debt projections
      </li>
    </ul>
    <a href="/register" class="w-full btn btn-lg btn-primary relative" id="register-with-lsac">
        Continue with your LawHub account
    </a>
  `,
  showCloseButton: true,
  showConfirmButton: false,
  didOpen: () => {
    const register = document.getElementById("register-with-lsac")

    if (register) {
      register.focus()
    }
  },
})
